<ion-content>
  <div>
    @if(isLoggedIn) {
    <app-header-logged [lang]="lang"/>
    } @else {
    <app-header [langSelected]="lang"/>
    }
    <app-loading-spinner />
    <main>
      <router-outlet />
    </main>
    <!-- <app-cookies></app-cookies> -->
    <app-footer></app-footer>
  </div>
</ion-content>
